import type { IncomeInvoiceDrillDown } from '@/lib/incomeInvoiceDrillDown'
import type { AgingContactDrillDown } from '@/pages/AgingReportPage'
import type { InvoiceFilters } from './InvoicesPage.types'

export function hasInvoiceFilters(filters: InvoiceFilters, ownerIds: ReadonlySet<string>) {
  return (
    filters.status !== 'all' ||
    filters.origin !== 'all' ||
    filters.issuedFrom !== '' ||
    filters.issuedThrough !== '' ||
    filters.openBalance ||
    ownerIds.size > 0
  )
}

/** The list request: every filter, drill-down and the search `q`, so the cursor binds to them all. */
export function invoicesPath(
  filters: InvoiceFilters,
  drillDown?: IncomeInvoiceDrillDown,
  agingContact?: AgingContactDrillDown,
  ownerIds: ReadonlySet<string> = new Set(),
  q = '',
) {
  const params = new URLSearchParams()
  if (drillDown) setDrillDownParams(params, drillDown)
  if (agingContact) {
    params.set('contact_id', String(agingContact.contactId))
    params.set('open_balance', 'true')
  }
  if (filters.status !== 'all') params.set('status', filters.status)
  if (filters.origin !== 'all') params.set('origin', filters.origin)
  if (filters.issuedFrom) params.set('issued_from', filters.issuedFrom)
  if (filters.issuedThrough) params.set('issued_through', filters.issuedThrough)
  if (filters.openBalance && !agingContact) params.set('open_balance', 'true')
  const owner = Array.from(ownerIds)[0]
  if (owner) params.set('owner', owner)
  if (q.trim()) params.set('q', q.trim())

  const query = params.toString()
  return query ? `/api/v1/invoices?${query}` : '/api/v1/invoices'
}

function setDrillDownParams(params: URLSearchParams, drillDown: IncomeInvoiceDrillDown) {
  params.set('income_starts_on', drillDown.startsOn)
  params.set('income_ends_on', drillDown.endsOn)
  params.set('income_grouping', drillDown.grouping)
  params.set('income_group_key', drillDown.groupKey)
  if (drillDown.granularity) params.set('income_granularity', drillDown.granularity)
}

export function invoiceTableState(isLoading: boolean, isError: boolean) {
  if (isLoading) return 'loading'
  if (isError) return 'error'

  return 'ready'
}
